export default "__VITE_ASSET__B63OCLvi__"